module.exports = __webpack_public_path__ + "img/flags/VU.61e90ff.png";